import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-24 md:py-32 bg-[#F8FAFC]">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-light tracking-tight text-[#0B1B32] mb-6" data-testid="privacy-title">
            Privacy Policy
          </h1>
          <p className="text-slate-600">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <div className="prose prose-lg max-w-none space-y-8">
            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">1. Introduction</h2>
              <p className="text-slate-600 leading-relaxed">
                Vista Global Trade ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">2. Information We Collect</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We collect the following types of information:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Contact information (name, email address, phone number, company name)</li>
                <li>Business inquiry details (product requirements, quantities, messages)</li>
                <li>Usage data (IP address, browser type, pages visited, time spent on site)</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">3. How We Use Your Information</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We use your personal data for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>To respond to your inquiries and provide customer support</li>
                <li>To process and fulfill your product requests</li>
                <li>To send you relevant business communications and updates</li>
                <li>To improve our website and services</li>
                <li>To comply with legal obligations</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">4. Data Storage and Security</h2>
              <p className="text-slate-600 leading-relaxed">
                We store your personal data securely in our database systems. We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">5. Data Sharing</h2>
              <p className="text-slate-600 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share your data with:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mt-4">
                <li>Service providers who assist in our business operations (under strict confidentiality agreements)</li>
                <li>Legal authorities when required by law or to protect our rights</li>
                <li>Business partners with your explicit consent</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">6. Your Rights</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                You have the following rights regarding your personal data:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Access: Request a copy of the personal data we hold about you</li>
                <li>Correction: Request correction of inaccurate or incomplete data</li>
                <li>Deletion: Request deletion of your personal data</li>
                <li>Objection: Object to processing of your personal data</li>
                <li>Portability: Request transfer of your data to another service</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">7. Cookies</h2>
              <p className="text-slate-600 leading-relaxed">
                Our website uses cookies to enhance user experience and analyze site usage. You can control cookie preferences through your browser settings. Disabling cookies may affect website functionality.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">8. Third-Party Links</h2>
              <p className="text-slate-600 leading-relaxed">
                Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">9. Data Retention</h2>
              <p className="text-slate-600 leading-relaxed">
                We retain your personal data for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce agreements.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">10. Changes to This Policy</h2>
              <p className="text-slate-600 leading-relaxed">
                We may update this privacy policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated effective date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-medium text-[#0B1B32] mb-4">11. Contact Us</h2>
              <p className="text-slate-600 leading-relaxed">
                If you have questions about this privacy policy or wish to exercise your data rights, please contact us at:
              </p>
              <p className="text-slate-600 mt-4">
                Email: info@vistaglobaltrade.com<br />
                Phone: +91 8882062043<br />
                Address: 313, U.S Complex, Jasola Vihar, Delhi-110076, India
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;